// prettier-ignore
export const sexEnum = [
  { id: 'MAN', label: 'Muž' },
  { id: 'WOMAN', label: 'Žena' }
];

// prettier-ignore
export const typeEnum = [
  { id: 'OFFICER', label: 'Strážník' },
  { id: 'WAITING_OFFICER', label: 'Čekatel' },
  { id: 'CIVILIAN', label: 'Civilní zaměstnanec' },
  { id: 'EXTERNAL', label: 'Externí zaměstnanec' }
];

// prettier-ignore
export const identificationTypeEnum = [
  { id: 'ID_CARD', label: 'Občanský průkaz' },
  { id: 'PASSPORT', label: 'Pas' },
  { id: 'IR', label: 'Povolení k pobytu' },
  { id: 'DRIVING_LICENCE', label: 'Řidičský průkaz' },
  { id: 'GUN_LICENCE', label: 'Zbrojní průkaz' },
  { id: 'OTHER', label: 'Jiný' }
];



// WEBPACK FOOTER //
// ./src/modules/employees/_employeesEnums.ts